
<template>
  <TabsBtn
    v-if="isShow"
    :tabs="tabs"
    :activeTab="activeTab"
    @change="changeTab"
    :isShowBorder="true"
  />
  <NoData v-else />

  <div v-if="isShow" class="as-h2h as-scrolling as-scrolling__result-popup">
    <div v-show="activeTab !== 'away'">
      <H2hTab
        :h2h="h2hHome"
        :teams="h2h.teams"
        :competitions="tournaments"
        :match="match"
        tab="home"
        :homeTeamId="match.home_team_id"
      />
      <NoData v-if="h2hHome.length === 0" />
    </div>
    <div v-show="activeTab !== 'home'">
      <H2hTab
        :h2h="h2hAway"
        :teams="h2h.teams"
        :competitions="tournaments"
        :match="match"
        tab="away"
        :homeTeamId="match.away_team_id"
      />
      <NoData v-if="h2hAway.length === 0" />
    </div>
  </div>
</template>

  <script setup lang="ts">
import { defineProps, ref, computed, getCurrentInstance } from "vue";
import type { IMatch, IH2h } from "~src/interfaces/tennis";
import H2hTab from "~src/components/h2h/tennis/H2hTab.vue";
import MatchEnum from "~src/enums/tennis/MatchEnum";
import NoData from "~src/components/NoData.vue";
import TabsBtn from "~src/components/TabsBtn.vue";

interface IProps {
  match: IMatch;
  h2h: IH2h;
}

const props = withDefaults(defineProps<IProps>(), {});

const instance: any = getCurrentInstance();
const activeTab = ref("home");

const tabs = ref([
  {
    title: props.match.home_team.short_name_vi || props.match.home_team.name,
    key: "home",
  },
  {
    title: props.match.away_team.short_name_vi || props.match.away_team.name,
    key: "away",
  },
]);

const changeTab = (val: string) => {
  activeTab.value = val;
};

const isShow = computed(() => {
  if (
    Object.keys(props.h2h).length === 0 ||
    JSON.stringify(props.h2h) === "{}"
  ) {
    return false;
  }
  return true;
});

const tournaments = computed(() => {
  if (instance?.proxy?.gSportType === "volleyball") {
    return props.h2h?.uniqueTournaments ?? [];
  }

  return props.h2h?.tournaments ?? [];
});

const h2hHome = computed(() => {
  if (!props.h2h || !Array.isArray(props.h2h.future.home)) {
    return [];
  }

  return props.h2h.future.home.filter((item: any) => {
    let check: any = item.status_id === MatchEnum.STATUS_NOT_STARTED;
    return check;
  });
});

const h2hAway = computed(() => {
  if (!props.h2h || !Array.isArray(props.h2h.future.away)) {
    return [];
  }

  return props.h2h.future.away.filter((item: any) => {
    let check: any = item.status_id === MatchEnum.STATUS_NOT_STARTED;
    return check;
  });
});
</script>

<script lang="ts">
export default {};
</script>
